import * as actionTypes from "./actionTypes";

const initialState = {
  session: false,
  token: null,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.sessionTimeOut:
      return {
        ...state,
        session: action.payload,
      };
    case actionTypes.getAccessToken:
      return {
        ...state,
        token: null,
      };
    case actionTypes.getAccessTokenSuccess:
      return {
        ...state,
        token: action.payload,
      };
    case actionTypes.getAccessTokenFailed:
      return {
        ...state,
        token: null,
      };
    default:
      return initialState;
  }
};

export default sessionReducer;
